export function getUserResponse() {
  try {
    return window.grecaptcha && window.grecaptcha.getResponse();
  } catch (error) {
    return false;
  }
}